export default __webpack_public_path__ + "static/media/logoSample2.8558093f.png";